import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { BookingPhotosComponent } from './booking-photos.component';
import { BookingPhotoCardModule } from '../booking-photo-card/booking-photo-card.module';
import { PhotoAppointmentSelectComponentModule } from '../photo-appointment-select/photo-appointment-select.module';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, BookingPhotoCardModule, PhotoAppointmentSelectComponentModule],
  declarations: [BookingPhotosComponent],
  exports: [BookingPhotosComponent]
})
export class BookingPhotosModule {}
